import { AdditionalFlexibleContentFragment, GetPageWrapperDataQuery } from "@graphqlTypes";
import { Banner, CarouselShop, Feature, FloatSpotlight, Title } from "@components";

interface MapProps {
  content: AdditionalFlexibleContentFragment['additionalFlexibleContent'];
}

export default function ContentMap({ content }: MapProps) {
  return (
    <>
      {content?.map((component, index) => {
        // Add more cases for other component types as needed
        switch (component.__typename) {
          case "CeremonyLandingAdditionalFlexibleContentCarouselShopLayout":
            return <CarouselShop key={index} {...component} />;
          case "CeremonyLandingAdditionalFlexibleContentFloatSpotlightLayout":
            return <FloatSpotlight key={index} {...component} />;
          case "CeremonyLandingAdditionalFlexibleContentTitleLayout":
            return <Title key={index} {...component} />;
          case "CeremonyLandingAdditionalFlexibleContentFeatureLayout":
            return <Feature key={index} {...component} />;
          case "CeremonyLandingAdditionalFlexibleContentBannerLayout":
            return <Banner key={index} {...component} />;
          default:
            // @ts-ignore Handle unknown component types gracefully
            console.warn(`MEDIA FLEXIBLE CONTENT: No component found for type: ${component.__typename}`);
            return null;
        }
      })}
    </>
  );
}
